/* @ngInject */
function AssetPreviewTabInfoController ($scope, $state, $window, $q, $timeout, $rootScope, $translate, Utils, ArtCollectionsService, UseTermsService, AdminService, TemplateService, UdsModalService, RepositoryService) {
  const getManageAssetsDialogController = () => $q.when(import('../../../repository/dialogs/manage-assets/manage-assets-dialog.controller'))
  $scope.isCustomizable = false
  $scope.details = {}
  $scope.product = null
  $scope.useTerms = null
  $scope.title = null
  $scope.type = null
  $scope.size = null
  $scope.dimension = null
  $scope.restriction = null
  $scope.download = null
  $scope.approval = null
  $scope.segmentation = null
  $scope.terms = null
  $scope.editedAt = null
  $scope.createdAt = null
  $scope.scheduleDate = null
  $scope.expirationDate = null
  const isCustomizationInfo = $scope.location === 'materialsCustomizations'

  const api = {
    _getInfo,
    _getAssetType,
    _getAssetPath,
    _getSize,
    _getTemplateDimensions,
    _getRestriction,
    _getGroups,
    _getUseTerms,
    _getUpdateDate,
    _getCreateDate,
    _formatDate,
    _truncateText,
    _updateCurrentTemplate,
    _getArtCollectionPath,
    _getRequestDate,
    _getFolderInfo,
    _getFolderPath
  }
  this.getApi = () => api

  $scope.$watchCollection('template', () => {
    const isTemplate = !$scope.template.isFolder && (!$scope.template.assetId || $scope.template.assetId !== $scope.template.id)
    const isFolder = $scope.template.isFolder
    $scope.details = $scope.template
    $scope.product = $scope.template.product

    if (isFolder) {
      api._getFolderInfo($scope.details)
    } else {
      api._getInfo($scope.details, $scope.product, isTemplate)
    }
  })

  $scope.openSettings = () => {
    getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          assets: [$scope.template]
        },
        onClose: (updatedAsset) => {
          if (!updatedAsset) {
            return
          }

          $scope.template.name = updatedAsset.name
          $rootScope.$emit('preview-header.update-template-name', updatedAsset.name)
        }
      })

      manageAssetsDialog.open()
    })
  }

  $scope.openFolderSettings = tabToOpen => {
    getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          folders: [$scope.template],
          tabToOpen
        },
        onClose: updatedFolder => {
          if (!updatedFolder) {
            return
          }

          $scope.template.title = updatedFolder.name
          $rootScope.$emit('asset-folder.update-folder-name', updatedFolder.id, updatedFolder.name)
        }
      })

      manageAssetsDialog.open()
    })
  }

  $scope.getCampaignInfoBannerText = () => {
    return $translate.instant('campaignInfoBanner.material', { campaignName: $scope.template?.campaignName })
  }

  function _getFolderInfo (details) {
    $timeout(() => {
      api._getFolderPath(details).then(path => {
        $scope.path = path
        $scope.title = details.title
        $scope.type = $translate.instant('folder')

        api._getCreateDate(details)
        api._getUpdateDate(details)
        api._getUseTerms(details)
      })
    }, true)
  }

  function _getInfo (details, product, isTemplate) {
    $scope.title = details.name
    $scope.isCustomizable = details.isCustomizable

    if (isTemplate) {
      $scope.scheduleDate = details.templateScheduleDate ? api._formatDate(details.templateScheduleDate) : null
      $scope.expirationDate = details.templateExpirationDate ? api._formatDate(details.templateExpirationDate) : null
      $scope.productTitle = product?.name
      api._getGroups(details)
      api._getUseTerms(details)

      if ($scope.location !== 'materialsApproval' || $rootScope.isUser()) {
        api._getTemplateDimensions(details)
      }

      if ($scope.location !== 'materialsApproval') {
        api._getUpdateDate(details)
      }

      if ($scope.template.isTemplate) {
        api._getRestriction(details)
        api._getAssetPath(details)
        $scope.approval = details.needApproval ? $translate.instant('yes') : $translate.instant('no')
        $scope.download = details.downloadOption.map((downloadOption) => {
          if (downloadOption === 'PDF') {
            return $translate.instant('digitalPDF')
          }

          if (downloadOption === 'PRINTABLE_PDF') {
            return $translate.instant('printablePDF')
          }

          return downloadOption
        }).join(', ')
      }
    }

    if ($scope.location !== 'materialsApproval') {
      api._getAssetType(details)
      api._getCreateDate(details)
      api._getUpdateDate(details)
    }

    if ($scope.location === 'materialsApproval' && !$rootScope.isUser()) {
      api._getRequestDate(details)
      api._getAssetPath(details)
    }

    api._getSize(details)
  }

  function _getAssetType (details) {
    $scope.type = details.isCustomizable
      ? $translate.instant('template')
      : details.asset?.extension.toUpperCase() || details.extension?.toUpperCase()
  }

  function _getAssetPath (details) {
    if ($scope.location === 'materialsApproval') {
      if ($scope.template.baseTemplateId) {
        return TemplateService.getTemplateDetailsForPreview($scope.template.baseTemplateId)
          .then(baseTemplate => {
            details.artCollectionId = baseTemplate.artCollectionId
            return api._getArtCollectionPath(details, true)
          })
      }

      return null
    }

    return api._getArtCollectionPath(details)
  }

  function _getArtCollectionPath (details, isApprovalInfo) {
    ArtCollectionsService.getArtCollectionPath(details.artCollectionId).then((collections) => {
      if (!collections.length) {
        return
      }

      if (collections.length === 1) {
        $scope.assetPath = collections[0].title
      } else if (collections.length === 2) {
        $scope.assetPath = `${collections[0].title}/${collections[1].title}`
      } else {
        $scope.assetPath = `${collections[0].title}/.../${collections[collections.length - 1].title}`
      }

      if (isApprovalInfo) {
        $scope.baseTemplate = $scope.assetPath
        $scope.assetPath = null
      }
    })
  }

  function _getSize (details) {
    const size = details.asset?.size || details?.size

    if (size) {
      $scope.size = Utils.getReadableFileSizeString(size)
    }
  }

  function _getTemplateDimensions (details) {
    const layer = details.layers?.[0]

    let height = layer?.height
    let width = layer?.width

    if (height || width) {
      if (layer.sizeUnit === 'CM' || details.product?.type === 'PRINTABLE') {
        height = Utils.convertPixelsToCm(height)
        width = Utils.convertPixelsToCm(width)
        $scope.dimensions = `${width} x ${height} cm`
        return
      } else {
        $scope.dimensions = `${width} x ${height} px`
        return
      }
    }

    $scope.dimensions = '-'
  }

  function _getRestriction (details) {
    const restriction = details?.customizationLevel
    const restrictions = {
      FREE_STYLE: $translate.instant('permissionFree'),
      RESTRICTED: $translate.instant('permissionRestricted'),
      ONLY_DOWNLOAD: $translate.instant('permissionAuto')
    }

    $scope.restriction = restrictions[restriction]
  }

  function _getGroups (details) {
    let truncatedGroups = ''
    const groupCount = details.groups.length
    const groupsMax = 2
    const groupsNameArray = details.groups.map(group => {
      return group.name
    })

    if (groupCount > groupsMax) {
      const groupString = api._truncateText(groupsNameArray.slice(0, groupsMax).join(', '), 15)
      truncatedGroups = `${groupString} +${groupCount - 2}`
    }

    $scope.segmentation = {
      title: groupsNameArray.join(', '),
      display: truncatedGroups || groupsNameArray.join(', ')
    }
  }

  function _getUseTerms (details) {
    if (details?.useTermsId) {
      UseTermsService.getUseTermsById(details.useTermsId).then((useTerms) => {
        $timeout(() => {
          $scope.useTerms = useTerms[0].title
        }, 0, true)
      })
    }
  }

  function _getFolderPath (folder) {
    return new Promise((resolve, reject) => {
      const organized = $translate.instant('repository.sidebarSections.organized')
      let path = `${organized}/${folder.title}`
      let currentFolder = folder

      function buildPath (folder) {
        if (!folder.parentId) {
          if (path.length > 20) {
            const folderName = folder.title
            path = `${organized}/.../${folderName}`
          }
          resolve(path)
          return
        }

        RepositoryService.getFolderById(folder.parentId)
          .then(subFolder => {
            const newPath = `${organized}/${subFolder.title}/${path.split('/').pop()}`

            if (newPath.length > 20) {
              path = `${organized}/.../${path.split('/').pop()}`
            } else {
              path = newPath
            }

            currentFolder = subFolder
            buildPath(currentFolder)
          })
          .catch(error => {
            reject(error)
          })
      }

      buildPath(currentFolder)
    })
  }

  function _getUpdateDate (details) {
    const date = api._formatDate(details.updatedAt)
    const by = $translate.instant('by')

    if ($rootScope.isUser() && isCustomizationInfo) {
      $scope.updateDate = `${date} ${by} ${$rootScope.oUser.name}`
      return
    }

    if ($scope.location === 'repository' || $scope.location === 'repositoryFolder') {
      const getUserPromise = (details.lastUpdateUserId || details.updatedAt)
        ? AdminService.getUserById(details.lastUpdateUserId || details.authorId)
        : Promise.resolve(null)

      getUserPromise.then((user) => {
        if (user) {
          $scope.updateDate = `${date} ${by} ${user.name}`
        } else {
          $scope.updateDate = api._formatDate(details.updatedAt)
        }
      })
    }

    $scope.updateDate = api._formatDate(details.updatedAt)
  }

  function _getCreateDate (details) {
    const by = $translate.instant('by')
    const date = api._formatDate(details.createdAt)
    const createdBy = details.createdBy || details.authorId

    if ($rootScope.isUser()) {
      if (!isCustomizationInfo) {
        return
      }

      $scope.createDate = `${date} ${by} ${$rootScope.oUser.name}`
      return
    }

    AdminService.getUserById(createdBy).then((user) => {
      $scope.createDate = `${date} ${by} ${user.name}`
    })
  }

  function _formatDate (dateISO = new Date()) {
    const configOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }

    const locale = $rootScope.oUser.locale
    const date = new Date(dateISO)
    return new Intl.DateTimeFormat(locale, configOptions).format(date)
  }

  function _truncateText (text, limit) {
    const lengthLimit = limit || 28

    if (text?.length > lengthLimit) {
      return text.slice(0, lengthLimit) + '...'
    } else {
      return text
    }
  }

  $scope.truncateText = api._truncateText
  $scope.goToAssetPath = () => {
    const url = $state.href('arts.collection', { id: $scope.details.artCollectionId })
    $window.open(url, '_blank')
  }

  $scope.$on('template-props.reload-data', () => {
    api._updateCurrentTemplate()
  })

  function _updateCurrentTemplate () {
    TemplateService.getTemplateDetailsForPreview($scope.template.id).then((template) => {
      $scope.template = template
    })
  }

  function _getRequestDate (details) {
    const date = api._formatDate(details.lastApprovalDate)
    const by = $translate.instant('by')

    AdminService.getUserById(details.createdBy).then((user) => {
      $scope.requestDate = `${date} ${by} ${user.name}`
    })
  }
}

export { AssetPreviewTabInfoController }
